import { createFileRoute } from '@tanstack/react-router';

import { useSEO, useBreadcrumbSchema, PageSEO } from '../lib/seo';
import { LegalDocPage } from '../components/legal/LegalDocPage';
// Body extracted verbatim from sites/www/public/legal/subprocessors/index.html (see privacy.tsx note).
import subprocessorsBody from '../content/legal/subprocessors.body.html?raw';

export const Route = createFileRoute('/legal/subprocessors')({
  component: SubprocessorsPage,
});

function SubprocessorsPage() {
  useSEO(PageSEO.subprocessors);
  useBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Trust', url: '/trust' },
    { name: 'Sub-processors', url: '/legal/subprocessors' },
  ]);

  return (
    <LegalDocPage
      title="Sub-processors register"
      breadcrumbLabel="Sub-processors"
      metaLine="v1.0 · 27 April 2026"
      subtitle="Every third-party processor that handles personal data on Neumind's behalf."
      wide
    >
      <div dangerouslySetInnerHTML={{ __html: subprocessorsBody }} />
    </LegalDocPage>
  );
}
